module.exports = __webpack_public_path__ + "sloth-61073f9ad904cc96dc9f.svg";